export class SchoolAgenda {
  id: number;
  schoolId: number;
  day: string;
  am1Start: string;
  am1End: string;
  am2Start: string;
  am2End: string;
  pm1Start: string;
  pm1End: string;
  pm2Start: string;
  pm2End: string;

  constructor(day: string) {
    this.day = day;
    this.am1Start = '06:30';
    this.am1End = '09:00';
    this.am2Start = '11:30';
    this.am2End = '13:00';
    this.pm1Start = '13:00';
    this.pm1End = '15:00';
    this.pm2Start = '17:30';
    this.pm2End = '19:00';
  }
}



// WEBPACK FOOTER //
// ./src/app/models/school-agenda.ts